/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowFigureACircleUpIcon16Light } from './ArrowFigureACircleUpIcon16Light';
import { ArrowFigureACircleUpIcon16Regular } from './ArrowFigureACircleUpIcon16Regular';
import { ArrowFigureACircleUpIcon16Solid } from './ArrowFigureACircleUpIcon16Solid';
import { ArrowFigureACircleUpIcon20Light } from './ArrowFigureACircleUpIcon20Light';
import { ArrowFigureACircleUpIcon20Regular } from './ArrowFigureACircleUpIcon20Regular';
import { ArrowFigureACircleUpIcon20Solid } from './ArrowFigureACircleUpIcon20Solid';
import { ArrowFigureACircleUpIcon24Regular } from './ArrowFigureACircleUpIcon24Regular';
import { ArrowFigureACircleUpIcon24Solid } from './ArrowFigureACircleUpIcon24Solid';
import { ArrowFigureACircleUpIcon32Regular } from './ArrowFigureACircleUpIcon32Regular';
import { ArrowFigureACircleUpIcon64Regular } from './ArrowFigureACircleUpIcon64Regular';
var sizes = {
    16: {
        light: ArrowFigureACircleUpIcon16Light,
        regular: ArrowFigureACircleUpIcon16Regular,
        solid: ArrowFigureACircleUpIcon16Solid,
    },
    20: {
        light: ArrowFigureACircleUpIcon20Light,
        regular: ArrowFigureACircleUpIcon20Regular,
        solid: ArrowFigureACircleUpIcon20Solid,
    },
    24: {
        regular: ArrowFigureACircleUpIcon24Regular,
        solid: ArrowFigureACircleUpIcon24Solid,
    },
    32: {
        regular: ArrowFigureACircleUpIcon32Regular,
    },
    64: {
        regular: ArrowFigureACircleUpIcon64Regular,
    },
};
export var ArrowFigureACircleUpIcon = forwardRef('ArrowFigureACircleUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
